// Internationalization for registration form
export const translations = {
  fr: {
    // Header
    title: "Bon de souscription pour tester gratuitement 30 jours QualiteeMed",
    subtitle: "Période d'essai résiliable à tout moment",
    
    // Form fields
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    practitionerName: "Nom & prénom du praticien",
    clinicName: "Nom du cabinet",
    clinicAddress: "Adresse du cabinet",
    clinicCity: "Ville",
    clinicPostalCode: "Code postal",
    clinicPhone: "Numéro de téléphone",
    clinicSize: "Taille du cabinet",
    demoPreference: "Je souhaite une démonstration personnalisée",
    patientFilePreferenceTitle: "Préférence de rédaction du dossier patient",
    patientFilePreferenceQuestion: "Lorsque vous rédigez vos dossiers patients, quel format préférez-vous ?",
    excludedDomainsTitle: "Domaines cliniques",
    excludedDomainsQuestion: "Parmi les domaines suivants, lesquels ne font pas partie de votre activité clinique ?",
    patientFilePreferenceOtherPlaceholder: "Précisez votre préférence",
    otherOption: "Autre",

    patientFilePreferenceOptions: {
      full_language: "Dossier principalement rédigé avec un langage complet",
      abbreviations: "Dossier principalement rédigé avec des abréviations médico-dentaires",
      no_preference: "Sans préférence particulière",
      other: "Autre"
    },
    excludedClinicalDomainOptions: {
      pediatric_dentistry: "Médecine dentaire pédiatrique",
      periodontology: "Parodontologie",
      oral_surgery: "Chirurgie orale",
      endodontics: "Endodontie",
      orthodontics: "Orthodontie",
      none: "Aucun"
    },

    // Placeholders
    emailPlaceholder: "votre.email@exemple.com",
    passwordPlaceholder: "Votre mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    practitionerNamePlaceholder: "Dr. Jean Dupont",
    clinicNamePlaceholder: "Cabinet Dentaire Dupont",
    clinicAddressPlaceholder: "Rue de la Paix 123",
    clinicCityPlaceholder: "Genève",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 praticien',
      '2-5': '2-5 praticiens',
      '6-15': '6-15 praticiens'
    },
    
    // Validation messages
    required: "Ce champ est requis",
    emailInvalid: "L'adresse e-mail n'est pas valide",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    passwordNoUpperCase: "Le mot de passe doit contenir au moins une majuscule",
    passwordNoLowerCase: "Le mot de passe doit contenir au moins une minuscule",
    passwordNoNumber: "Le mot de passe doit contenir au moins un chiffre",
    passwordNoSpecialChar: "Le mot de passe doit contenir au moins un caractère spécial (!@#$%^&*)",
    passwordsNotMatch: "Les mots de passe ne correspondent pas",
    postalCodeInvalid: "Le code postal doit contenir 4 chiffres",
    patientFilePreferenceOtherRequired: "Veuillez préciser votre préférence",
    excludedDomainsRequired: "Veuillez sélectionner au moins un domaine",
    excludedDomainsConflict: "« Aucun » ne peut pas être combiné avec d'autres domaines",
    formValidationTitle: "Le formulaire contient des erreurs",
    formValidationSummary: "Veuillez corriger les champs en rouge avant de soumettre votre inscription.",

    // Buttons
    submit: "Commencer l'essai gratuit",
    submitting: "Envoi en cours...",
    
    // Success message
    successTitle: "Merci pour votre inscription !",
    successMessage: "Votre demande d'essai gratuit a été envoyée avec succès. Notre équipe vous contactera dans les plus brefs délais pour activer votre compte.",
    backToWebsite: "Retourner sur QualiteeMed",
    
    // Help text
    helpTitle: "Besoin d'aide ?",
    helpDescription: "Pour toute question n'hésitez pas à nous contacter :",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Une inscription avec cette adresse e-mail existe déjà",
    emailAlreadyUsed: "Cette adresse e-mail est déjà utilisée",
    submitError: "Une erreur est survenue lors de l'envoi. Veuillez réessayer."
  },
  
  en: {
    // Header
    title: "QualiteeMed 30-Day Free Trial Subscription Form",
    subtitle: "Trial period can be cancelled at any time",
    
    // Form fields
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    practitionerName: "Practitioner name",
    clinicName: "Clinic name",
    clinicAddress: "Clinic address",
    clinicCity: "City",
    clinicPostalCode: "Postal code",
    clinicPhone: "Phone number",
    clinicSize: "Clinic size",
    demoPreference: "I would like a personalized demonstration",
    patientFilePreferenceTitle: "Patient file writing preference",
    patientFilePreferenceQuestion: "When writing patient files, which format do you prefer?",
    excludedDomainsTitle: "Clinical domains",
    excludedDomainsQuestion: "Which of the following domains are not part of your clinical practice?",
    patientFilePreferenceOtherPlaceholder: "Specify your preference",
    otherOption: "Other",

    patientFilePreferenceOptions: {
      full_language: "Patient files mainly written in full language",
      abbreviations: "Patient files mainly written with medical-dental abbreviations",
      no_preference: "No particular preference",
      other: "Other"
    },
    excludedClinicalDomainOptions: {
      pediatric_dentistry: "Pediatric dentistry",
      periodontology: "Periodontology",
      oral_surgery: "Oral surgery",
      endodontics: "Endodontics",
      orthodontics: "Orthodontics",
      none: "None"
    },

    // Placeholders
    emailPlaceholder: "your.email@example.com",
    passwordPlaceholder: "Your password",
    confirmPasswordPlaceholder: "Confirm password",
    practitionerNamePlaceholder: "Dr. John Smith",
    clinicNamePlaceholder: "Smith Dental Clinic",
    clinicAddressPlaceholder: "Peace Street 123",
    clinicCityPlaceholder: "Geneva",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 practitioner',
      '2-5': '2-5 practitioners',
      '6-15': '6-15 practitioners'
    },
    
    // Validation messages
    required: "This field is required",
    emailInvalid: "Email address is not valid",
    passwordMinLength: "Password must contain at least 8 characters",
    passwordNoUpperCase: "Password must contain at least one uppercase letter",
    passwordNoLowerCase: "Password must contain at least one lowercase letter",
    passwordNoNumber: "Password must contain at least one number",
    passwordNoSpecialChar: "Password must contain at least one special character (!@#$%^&*)",
    passwordsNotMatch: "Passwords do not match",
    postalCodeInvalid: "Postal code must contain 4 digits",
    patientFilePreferenceOtherRequired: "Please specify your preference",
    excludedDomainsRequired: "Please select at least one domain",
    excludedDomainsConflict: "« None » cannot be combined with other domains",
    formValidationTitle: "The form contains errors",
    formValidationSummary: "Please correct the highlighted fields before submitting your registration.",

    // Buttons
    submit: "Start free trial",
    submitting: "Submitting...",
    
    // Success message
    successTitle: "Thank you for your registration!",
    successMessage: "Your free trial request has been sent successfully. Our team will contact you shortly to activate your account.",
    backToWebsite: "Back to QualiteeMed",
    
    // Help text
    helpTitle: "Need help?",
    helpDescription: "For any questions, please don't hesitate to contact us:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "A registration with this email address already exists",
    emailAlreadyUsed: "This email address is already in use",
    submitError: "An error occurred while sending. Please try again."
  },
  
  de: {
    // Header
    title: "QualiteeMed 30-Tage kostenlose Testversion Abonnement",
    subtitle: "Testzeitraum kann jederzeit gekündigt werden",
    
    // Form fields
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    practitionerName: "Name des Praktikers",
    clinicName: "Praxisname",
    clinicAddress: "Praxisadresse",
    clinicCity: "Stadt",
    clinicPostalCode: "Postleitzahl",
    clinicPhone: "Telefonnummer",
    clinicSize: "Praxigröße",
    demoPreference: "Ich möchte eine personalisierte Demonstration",
    patientFilePreferenceTitle: "Präferenz für die Patientenakte",
    patientFilePreferenceQuestion: "Welches Format bevorzugen Sie beim Verfassen von Patientenakten?",
    excludedDomainsTitle: "Klinische Bereiche",
    excludedDomainsQuestion: "Welche der folgenden Bereiche gehören nicht zu Ihrer klinischen Tätigkeit?",
    patientFilePreferenceOtherPlaceholder: "Geben Sie Ihre Präferenz an",
    otherOption: "Andere",

    patientFilePreferenceOptions: {
      full_language: "Patientenakte hauptsächlich in vollständiger Sprache",
      abbreviations: "Patientenakte hauptsächlich mit medizinisch-zahnmedizinischen Abkürzungen",
      no_preference: "Keine besondere Präferenz",
      other: "Andere"
    },
    excludedClinicalDomainOptions: {
      pediatric_dentistry: "Kinderzahnheilkunde",
      periodontology: "Parodontologie",
      oral_surgery: "Mundchirurgie",
      endodontics: "Endodontie",
      orthodontics: "Kieferorthopädie",
      none: "Keiner"
    },

    // Placeholders
    emailPlaceholder: "ihre.email@beispiel.com",
    passwordPlaceholder: "Ihr Passwort",
    confirmPasswordPlaceholder: "Passwort bestätigen",
    practitionerNamePlaceholder: "Dr. Hans Müller",
    clinicNamePlaceholder: "Zahnarztpraxis Müller",
    clinicAddressPlaceholder: "Friedensstraße 123",
    clinicCityPlaceholder: "Genf",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 Praktiker',
      '2-5': '2-5 Praktiker',
      '6-15': '6-15 Praktiker'
    },
    
    // Validation messages
    required: "Dieses Feld ist erforderlich",
    emailInvalid: "E-Mail-Adresse ist nicht gültig",
    passwordMinLength: "Passwort muss mindestens 8 Zeichen enthalten",
    passwordNoUpperCase: "Passwort muss mindestens einen Großbuchstaben enthalten",
    passwordNoLowerCase: "Passwort muss mindestens einen Kleinbuchstaben enthalten",
    passwordNoNumber: "Passwort muss mindestens eine Ziffer enthalten",
    passwordNoSpecialChar: "Passwort muss mindestens ein Sonderzeichen enthalten (!@#$%^&*)",
    passwordsNotMatch: "Passwörter stimmen nicht überein",
    postalCodeInvalid: "Postleitzahl muss 4 Ziffern enthalten",
    patientFilePreferenceOtherRequired: "Bitte geben Sie Ihre Präferenz an",
    excludedDomainsRequired: "Bitte wählen Sie mindestens einen Bereich",
    excludedDomainsConflict: "« Keiner » kann nicht mit anderen Bereichen kombiniert werden",
    formValidationTitle: "Das Formular enthält Fehler",
    formValidationSummary: "Bitte korrigieren Sie die rot markierten Felder, bevor Sie Ihre Anmeldung absenden.",

    // Buttons
    submit: "Kostenlose Testversion starten",
    submitting: "Wird gesendet...",
    
    // Success message
    successTitle: "Vielen Dank für Ihre Anmeldung!",
    successMessage: "Ihre Anfrage für eine kostenlose Testversion wurde erfolgreich gesendet. Unser Team wird Sie in Kürze kontaktieren, um Ihr Konto zu aktivieren.",
    backToWebsite: "Zurück zu QualiteeMed",
    
    // Help text
    helpTitle: "Brauchen Sie Hilfe?",
    helpDescription: "Bei Fragen zögern Sie nicht, uns zu kontaktieren:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Eine Registrierung mit dieser E-Mail-Adresse existiert bereits",
    emailAlreadyUsed: "Diese E-Mail-Adresse wird bereits verwendet",
    submitError: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut."
  },
  
  it: {
    // Header
    title: "QualiteeMed Abbonamento Prova Gratuita 30 Giorni",
    subtitle: "Periodo di prova cancellabile in qualsiasi momento",
    
    // Form fields
    email: "Email",
    password: "Password",
    confirmPassword: "Conferma password",
    practitionerName: "Nome del professionista",
    clinicName: "Nome della clinica",
    clinicAddress: "Indirizzo della clinica",
    clinicCity: "Città",
    clinicPostalCode: "Codice postale",
    clinicPhone: "Numero di telefono",
    clinicSize: "Dimensione della clinica",
    demoPreference: "Vorrei una dimostrazione personalizzata",
    patientFilePreferenceTitle: "Preferenza di redazione del fascicolo paziente",
    patientFilePreferenceQuestion: "Quando redigete i fascicoli dei pazienti, quale formato preferite?",
    excludedDomainsTitle: "Domini clinici",
    excludedDomainsQuestion: "Quali dei seguenti domini non fanno parte della vostra attività clinica?",
    patientFilePreferenceOtherPlaceholder: "Specificate la vostra preferenza",
    otherOption: "Altro",

    patientFilePreferenceOptions: {
      full_language: "Fascicolo principalmente redatto con un linguaggio completo",
      abbreviations: "Fascicolo principalmente redatto con abbreviazioni medico-dentistiche",
      no_preference: "Nessuna preferenza particolare",
      other: "Altro"
    },
    excludedClinicalDomainOptions: {
      pediatric_dentistry: "Odontoiatria pediatrica",
      periodontology: "Parodontologia",
      oral_surgery: "Chirurgia orale",
      endodontics: "Endodonzia",
      orthodontics: "Ortodonzia",
      none: "Nessuno"
    },

    // Placeholders
    emailPlaceholder: "vostra.email@esempio.com",
    passwordPlaceholder: "La vostra password",
    confirmPasswordPlaceholder: "Conferma password",
    practitionerNamePlaceholder: "Dr. Mario Rossi",
    clinicNamePlaceholder: "Clinica Dentale Rossi",
    clinicAddressPlaceholder: "Via della Pace 123",
    clinicCityPlaceholder: "Ginevra",
    clinicPostalCodePlaceholder: "1200",
    clinicPhonePlaceholder: "+41 22 123 45 67",
    
    // Clinic size options
    clinicSizeOptions: {
      '1': '1 professionista',
      '2-5': '2-5 professionisti',
      '6-15': '6-15 professionisti'
    },
    
    // Validation messages
    required: "Questo campo è obbligatorio",
    emailInvalid: "L'indirizzo email non è valido",
    passwordMinLength: "La password deve contenere almeno 8 caratteri",
    passwordNoUpperCase: "La password deve contenere almeno una lettera maiuscola",
    passwordNoLowerCase: "La password deve contenere almeno una lettera minuscola",
    passwordNoNumber: "La password deve contenere almeno un numero",
    passwordNoSpecialChar: "La password deve contenere almeno un carattere speciale (!@#$%^&*)",
    passwordsNotMatch: "Le password non corrispondono",
    postalCodeInvalid: "Il codice postale deve contenere 4 cifre",
    patientFilePreferenceOtherRequired: "Specificate la vostra preferenza",
    excludedDomainsRequired: "Selezionate almeno un dominio",
    excludedDomainsConflict: "« Nessuno » non può essere combinato con altri domini",
    formValidationTitle: "Il modulo contiene errori",
    formValidationSummary: "Correggete i campi evidenziati in rosso prima di inviare la registrazione.",

    // Buttons
    submit: "Inizia prova gratuita",
    submitting: "Invio in corso...",
    
    // Success message
    successTitle: "Grazie per la vostra registrazione!",
    successMessage: "La vostra richiesta di prova gratuita è stata inviata con successo. Il nostro team vi contatterà a breve per attivare il vostro account.",
    backToWebsite: "Torna a QualiteeMed",
    
    // Help text
    helpTitle: "Avete bisogno di aiuto?",
    helpDescription: "Per qualsiasi domanda, non esitate a contattarci:",
    helpEmail: "info@qualiteemed.ai",
    helpPhone: "076 408 12 08",

    // Error messages
    emailAlreadyExists: "Esiste già una registrazione con questo indirizzo email",
    emailAlreadyUsed: "Questo indirizzo email è già in uso",
    submitError: "Si è verificato un errore durante l'invio. Riprovate."
  }
};

// Language detection
export const detectLanguage = () => {
  // Check URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang && translations[urlLang]) {
    return urlLang;
  }
  
  // Check localStorage
  const storedLang = localStorage.getItem('registration-language');
  if (storedLang && translations[storedLang]) {
    return storedLang;
  }
  
  // Check browser language
  const browserLang = navigator.language.split('-')[0];
  if (translations[browserLang]) {
    return browserLang;
  }
  
  // Default to French
  return 'fr';
};

// Set language
export const setLanguage = (lang) => {
  if (translations[lang]) {
    localStorage.setItem('registration-language', lang);
    return lang;
  }
  return 'fr';
};
